import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Copy, Check, Info } from "lucide-react";

export default function SSOIdpLoginUrl({ idpLoginUrl, providerType }) {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);
    const [showHelp, setShowHelp] = useState(false);

    if (!idpLoginUrl) return null;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(idpLoginUrl);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            /* clipboard not available */
        }
    };

    const helpKey = providerType === "okta"
        ? "ssoSettings.idpHelpOkta"
        : providerType === "azure_ad"
        ? "ssoSettings.idpHelpAzure"
        : "ssoSettings.idpHelpGeneric";

    return (
        <div>
            <div className="flex items-center gap-1 mb-1">
                <label className="block text-sm font-medium text-gray-700">
                    {t("ssoSettings.idpLoginUrlLabel")}
                </label>
                <button type="button" onClick={() => setShowHelp(!showHelp)} className="text-gray-400 hover:text-gray-600">
                    <Info className="w-3.5 h-3.5" />
                </button>
            </div>
            <p className="text-xs text-gray-500 mb-2">{t("ssoSettings.idpLoginUrlHelp")}</p>
            {showHelp && (
                <p className="text-xs text-blue-700 bg-blue-50 border border-blue-200 rounded-md p-2 mb-2">
                    {t(helpKey)}
                </p>
            )}
            <div className="flex gap-2">
                <input type="text" readOnly value={idpLoginUrl}
                    className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm bg-gray-50 text-gray-700" />
                <button type="button" onClick={handleCopy}
                    className="inline-flex items-center gap-1 px-3 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50">
                    {copied ? <Check className="w-4 h-4 text-green-600" /> : <Copy className="w-4 h-4" />}
                    {copied ? t("ssoSettings.copied") : t("ssoSettings.copy")}
                </button>
            </div>
        </div>
    );
}
